import * as S from "@/components/ManagementAuthorization/ManagementAuthorization.style";
import { useEffect, useState } from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import { useHistory } from "react-router-dom";
import { DefaultButton } from "@fluentui/react";
import { closeBtnStyle } from "@/components/GlobalStyle";
import { Check } from "../ConvenienceTest/assets";

const ModalComplete = ({
  title,
  body,
  buttonText = "Continuar",
  setModalShow,
  isPromotioned,
  returnPath,
}: {
  title: string;
  body: string[];
  buttonText?: string;
  setModalShow: any;
  isPromotioned?: boolean | undefined;
  returnPath: string;
}) => {
  const history = useHistory();
  const [height, setHeight] = useState("");

  useEffect(() => {
    const toheight = document?.querySelector("#root")?.scrollHeight + "px";
    setHeight(toheight);
  }, []);

  return (
    <>
      <S.HelperStyle />
      <S.ModalMainCont>
        <S.ToExitCont>
          <S.ToExit>
            <Icon
              iconName="ChromeClose"
              // @ts-ignore
              styles={closeBtnStyle}
              onClick={() => setModalShow(false)}
            />
          </S.ToExit>
        </S.ToExitCont>
        <S.CompletedIcon src={Check} />
        <S.Continue>{title}</S.Continue>
        <hr />
        <S.NeedsCont>
          {body.map((text, index) => (
            <p key={index}>{text}</p>
          ))}
        </S.NeedsCont>
        <S.BtnCont>
          <DefaultButton
            onClick={() =>
              history.push(isPromotioned === true ? "/promotioned" : returnPath)
            }
            className="button tiny-primary-button"
          >
            {buttonText}
          </DefaultButton>
        </S.BtnCont>
      </S.ModalMainCont>
      <S.Focus
        className="modal"
        // @ts-ignore
        height={height}
      />
    </>
  );
};

export default ModalComplete;
